<template>
  <div>
    <el-row>
      <span><h1>{{ headerTitel }}</h1></span>
    </el-row>
    <el-row>
      <el-form
        :inline="true"
        class="demo-form-inline"
        label-position="right"
        label-width="100px"
        :model="searchForm"
      >
        <el-form-item label="选择站点:" prop="stationId">
          <el-select
            style="width: 85%"
            v-model="searchForm.stationId"
            placeholder="请选择"
            @change="stationIdChange"
          >
            <el-option
              v-for="item in stationIdOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:" label-width="300" >
          <el-date-picker
            v-model="searchForm.startTime"
            clearable
            type="date"
            placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <!-- <el-input placeholder="请输入手机号" clear width="180px" v-model="searcheForm.phone"></el-input> -->
        </el-form-item>
        <el-form-item label="更新日期:" >
          <el-date-picker
            v-model="searchForm.endTime"
            clearable
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <!-- <el-input placeholder="请输入地址" clear width="180px" v-model="searcheForm.name"></el-input> -->
        </el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="search"
          >搜索</el-button
        >

        &nbsp;&nbsp;

        <el-button icon="el-icon-search" type="primary" @click="clearForm"
          >清除</el-button
        >
      </el-form>
    </el-row>
    <el-card>
       <el-row v-if="reportData1.default!=undefined" >
          <el-col :span="24">
          <p><h1>自定义站点 {{this.stationName}}</h1></p>
          <p><h1>自定义 {{this.searchForm.startTime}} 至 {{this.searchForm.endTime}}</h1></p>
          <p><span>收入：{{ reportData1.default.totalMoney }} </span>元</p>
          <p><span>电量：{{ reportData1.default.totalQuantity }} 度</span></p>
          <p><span>时长：{{ reportData1.default.totalHours }} </span>小时</p>
       </el-col>
       </el-row>
      <el-row>
       <el-col :span="6">
          <p><h1>今日</h1></p>
          <p><span>收入：{{ reportData1.today.totalMoney }} </span>元</p>
          <p><span>电量：{{ reportData1.today.totalQuantity }} 度</span></p>
          <p><span>时长：{{ reportData1.today.totalHours }} </span>小时</p>
       </el-col>
       <el-col :span="6">
          <p><h1>昨日</h1></p>
          <p><span>收入：{{ reportData1.yesterday.totalMoney }} </span>元</p>
          <p><span>电量：{{ reportData1.yesterday.totalQuantity }} </span>度</p>
          <p><span>时长：{{ reportData1.yesterday.totalHours }} 小时</span></p>
       </el-col>
       <el-col :span="6">
          <p><h1>本月累计</h1></p>
          <p><span>收入：{{ reportData1.currentMonth.totalMoney }} 元</span></p>
          <p><span>电量：{{ reportData1.currentMonth.totalQuantity }} </span>度</p>
          <p><span>时长：{{ reportData1.currentMonth.totalHours }} </span>小时</p>
       </el-col>
       <el-col :span="6">
          <p><h1>上月累计</h1></p>
          <p><span>收入：{{ reportData1.lastMonth.totalMoney }} 元</span></p>
          <p><span>电量：{{ reportData1.lastMonth.totalQuantity }} </span>度</p>
          <p><span>时长：{{ reportData1.lastMonth.totalHours }} </span>小时</p>
       </el-col>
    </el-row>
    </el-card>
	
	   <el-row >
	      <el-col :span="12"  v-for="(item,key) in reportData1" :key="key" > 
			  <el-card shadow="always" style="background-color: #73C0DE ;">
				  <div slot="header" class="clearfix" >
				      <span><h1>{{item.title}}</h1></span>
				    </div>
		  <p><h1>{{item.statisticalDate}}</h1></p>
	      <p><span>累计收入：{{item.totalMoney }} </span>元</p>
		  <p><span>累计退费：{{ item.totalRefundFee }} </span>元</p>
		  <p><span>实际收入：{{ item.totalActualAmount }} </span>元</p>
	      <p><span>电量：{{ item.totalQuantity }} 度</span></p>
	      <p><span>时长：{{ item.totalHours }} </span>小时</p>
		  </el-card>
	   </el-col>
	   </el-row>

    <!-- <el-row>
      <h1>图标</h1>
      <div id="myChart" :style="{width: '300px', height: '300px'}"></div>
    </el-row> -->

  </div>
</template>
<script>
import {apiListStations} from '../charge/charge-equipment' ;
import {apiStatistical,apiStatisticalReportData,apiStatisticalExport} from  './api';
export default {
  name: "StatisticalView",
  data() {
    return {
	  color:[ "#1890FF",
        "#91CB74",
        "#FAC858",
        "#EE6666",
        "#73C0DE",
        "#3CA272",
        "#FC8452",
        "#9A60B4",
        "#ea7ccc"],
      headerTitel: "充电订单统计",
      stationIdOptions:[],
      todayTotalMoney:999.00,
      monthTotalMoney:29999.88,
      stationName:null,
      searchForm: {
        stationId: null,
        page:1,
        size:1000
      },
      reportData1:{
        today:{
          totalMinutes:null,totalQuantity:null,totalMoney:null
        },
        yesterday:{totalMinutes:null,totalQuantity:null,totalMoney:null},
        lastMonth:{totalMinutes:null,totalQuantity:null,totalMoney:null},
        currentMonth:{totalMinutes:null,totalQuantity:null,totalMoney:null}
      }
    };
  },
  created() {
    this.initSelectStations() ;
    this.reportData();
  },
  mounted(){
    // this.drawLine();

  },
  methods: {
    reportData(){
        apiStatisticalReportData({}).then((resp)=>{
              this.reportData1=resp.data;
        });
    },
    search(){
       this.searchData();
    },
    searchData(){
       apiStatistical(this.searchForm).then((resp)=>{
          console.log('=========='+JSON.stringify(resp.data));
           this.reportData1=resp.data;
       })
    },
    clearForm(){
      this.searchForm={};
      this.stationName=null;
    },
    initSelectStations() {
      apiListStations(this.searchForm).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
            });
          });
        }
      });
    },
    stationIdChange(v){
      console.log('U Selected '+v);
      this.stationIdOptions.forEach(e=>{
        if(e.value==v){
          this.stationName=e.label;
        }
      })
    },
    drawLine () {
      // var echarts = require('echarts');
      var myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        title: {
          text: 'ECharts 入门示例'
        },
        tooltip: {},
        xAxis: {
          data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: [5, 20, 36, 10, 10, 20]
        }]
      });
    }
  },
};
</script>